import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";

const ViewContactUs = () => {
  const { id } = useParams();
  const [contact, setContact] = useState(null);
  const [error, setError] = useState("");
  const URL = process.env.REACT_APP_URL;

  useEffect(() => {
    axios
      .get(`${URL}contactus/${id}`)
      .then((response) => {
        setContact(response.data);
        setError("");
      })
      .catch(() => {
        setError("Error fetching contact details.");
      });
  }, [id, URL]);

  if (error) {
    return <div className="text-red-500 text-center mt-4">{error}</div>;
  }

  if (!contact) {
    return <div className="text-center mt-4 text-gray-600">Loading...</div>;
  }

  return (
    <div className="flex justify-center items-center min-screen p-10">
      <div className="bg-white shadow-lg rounded-xl w-full max-w-4xl p-6 border border-gray-200 flex flex-col md:flex-row">
        <div className="w-full flex flex-col justify-center px-6 space-y-4">
          <div className="flex flex-col">
            <span className="text-black-500  font-semibold text-sm">
              Name :
            </span>
            <span className="text-base text-gray-500">{contact.name}</span>
          </div>

          <div className="flex flex-col">
            <span className="text-balck-500 font-semibold text-sm">Email:</span>
            <span className="text-gray-500 text-base">{contact.email}</span>
          </div>

          <div className="flex flex-col">
            <span className="text-black-500  font-semibold text-sm">
              Company Name:
            </span>
            <span className="text-gray-500 text-base">
              {contact.companyname}
            </span>
          </div>

          <div className="flex flex-col">
            <span className="text-black-500  font-semibold text-sm">
              Mobile No:
            </span>
            <span className="text-gray-500 text-base">{contact.mobileno}</span>
          </div>

          <div className="flex flex-col">
            <span className="text-black-500  font-semibold text-sm">
              Reason for Contact:
            </span>
            <p className="text-gray-500 text-base leading-relaxed">
              {contact.reasonforcontact}
            </p>
          </div>

          <div className="flex flex-col">
            <span className="text-black-500  font-semibold text-sm">
              Additional Details:
            </span>
            <p className="text-gray-500 text-base leading-relaxed">
              {contact.additionaldetails}
            </p>
          </div>

          <div className="flex space-x-4">
            <Link to="/contactUs">
              <button className="px-6 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition">
                Back to List
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewContactUs;
